export default __webpack_public_path__ + "static/media/indexxHiveCaptionBee.2f2024c9.svg";